import clsx from 'clsx';
export var concatStyles = function () {
    var styles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styles[_i] = arguments[_i];
    }
    return clsx.apply(void 0, styles);
};
